import { DEFAULT_DATE_TIME_FORMAT } from "@app/constants";
import dayjs from "dayjs";
import { Buffer } from "buffer";

export const formatMoneyVN = (
  money: number | string,
  options?: Intl.NumberFormatOptions
) => {
  return Intl.NumberFormat("vi-VN", options).format(Number(money));
};

export const generateQRCode = (
  bankName: string,
  bankNumber: string,
  bankOwner: string,
  money: string | number,
  content: string
) => {
  return `https://img.vietqr.io/image/${bankName}-${bankNumber}-print.png?amount=${money}&addInfo=${content}&accountName=${bankOwner}`;
};

export const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const formatDate = (
  dateTime: dayjs.ConfigType,
  format = DEFAULT_DATE_TIME_FORMAT
) => {
  return dayjs(dateTime).format(format);
};

export const downloadFile = (
  data: any,
  dataType?: string,
  fileName?: string
) => {
  const binaryData = [];

  binaryData.push(data);
  const downloadLink = document.createElement("a");

  downloadLink.href = window.URL.createObjectURL(
    new Blob(binaryData, { type: dataType })
  );

  if (fileName) downloadLink.setAttribute("download", fileName);

  downloadLink.click();
};

export const dataURLToFile = (dataURL: string, fileName: string) => {
  const arr = dataURL.split(",");
  const mime = arr[0]?.match(/:(.*?);/)?.[1];
  const bstr = Buffer.from(arr[arr.length - 1], "base64").toString("ascii");
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};

/**
 * Thời điểm kết thúc của order: end_time nếu có,
 * nếu chưa có thì time_boot + rental_period (giờ), giống trang Quản lý đơn hàng.
 */
/**
 * Hạn sử dụng Image Cloud = createdAt + days_of_use ngày, tính theo mili giây như cron autoImageCloud của API
 * (days_of_use có thể lẻ ngày khi gia hạn Image đã quá hạn; dayjs.add(n, "day") làm tròn ngày nên không dùng)
 */
export const getCloudExpiry = (image: { createdAt: string | number | Date; days_of_use?: number }) =>
  dayjs(new Date(image.createdAt).getTime() + (image.days_of_use || 0) * 24 * 60 * 60 * 1000);

export const getOrderEndTime = (order: { end_time?: number; time_boot: number; rental_period: number }) =>
  order.end_time ? dayjs(order.end_time) : dayjs(order.time_boot).add(order.rental_period, "h");

/**
 * Thứ tự hiển thị admin nhập (sort_order, không bắt buộc) tăng dần, chưa nhập thì xếp sau,
 * cùng thứ tự thì giữ nguyên thứ tự cũ (sort ổn định). API đã xếp sẵn /categories, /packages.
 */
export const bySortOrder = (a: { sort_order?: number | null }, b: { sort_order?: number | null }) => {
  const hasA = typeof a.sort_order === "number";
  const hasB = typeof b.sort_order === "number";

  if (hasA !== hasB) return hasA ? -1 : 1;

  return hasA ? (a.sort_order as number) - (b.sort_order as number) : 0;
};
